import React from 'react';
import {View, StyleSheet, Text} from 'react-native';
import CustomPressable from '../customPressable/customPressable';
import { COLORS } from '../../style';

const CustomCheckBoxWithProps = (props) => {

  const {value, onValueChange, checkBoxStyle={}} = props || {};

  return (
    <CustomPressable
      style={styles.checkboxContainer}
      onPress={onValueChange}>
      <View style={[styles.checkbox, value && styles.checkedCheckbox,  checkBoxStyle]}>
        {value && <Text style={styles.checkMark}>✓</Text>}
      </View>
    </CustomPressable>
  );
};

const styles = StyleSheet.create({
  checkboxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
  },
  checkbox: {
    display: "flex",
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: 'grey',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkedCheckbox: {
    backgroundColor: COLORS.SECONDARY_COLOR,
  },
  checkMark: {
    color: COLORS.SECONDARY_TEXT_COLOR,
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 1,
  },
});

export default CustomCheckBoxWithProps;